module.exports = __webpack_public_path__ + "img/meet-your-side-kicks.a8fd9ea4.png";